<div class="toolbar" role="banner">
  <img alt="Angular Logo" src="assets/images/jpm-logo.png" />
  <!-- <span>JPMC Payment</span> -->
  <div class="spacer"></div>
</div>

<img src="assets/images/trimble.jpg" class="img-propare" />
<div class="card-container container" role="main">
  <div class="content" role="main">
    <div class="row">
      <div class="col-lg-3">
        <div class="image-field">
          <img src="assets/images/Noble.png" />
          <!-- <h4>JPMC</h4> -->
        </div>
      </div>

      <div class="col-lg-9">
        <section class="example-section">
          <form [formGroup]="form">
            <h4 class="example-section">Payment Details</h4>
            <mat-grid-list cols="3" rowHeight="80px" gutterSize="15px">
              <!-- <mat-form-field appearance="outline">
                    <mat-label>VAN Number</mat-label>
                    <input type="text" maxlength="100" matInput formControlName="vanNumber" placeholder="Enter VAN Number" onkeypress='return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || event.charCode == 32' required>
                    <mat-error *ngIf="form.controls['vanNumber'].hasError('required')">VAN Number is required.</mat-error>
                    <mat-error *ngIf="form.controls['vanNumber'].hasError('pattern')">Invalid VAN Number</mat-error>
                  </mat-form-field> -->

              <mat-form-field appearance="outline">
                <mat-label>VAN Number </mat-label>
                <input
                  type="text"
                  maxlength="20"
                  matInput
                  placeholder="Enter VAN Number"
                  formControlName="vanNumber"
                  autocomplete="off"
                  maxlength="10"
                  required
                  (input)="onInput($event)"
                />
                <mat-error
                  *ngIf="form.controls['vanNumber'].hasError('required')"
                  >VAN Number is required.</mat-error
                >
                <mat-error
                  *ngIf="form.controls['vanNumber'].hasError('pattern')"
                  >Invalid VAN Number</mat-error
                >
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Customer Name</mat-label>
                <input
                  type="text"
                  matInput
                  formControlName="customerName"
                  placeholder="Enter Customer Name"
                  maxlength="30"
                  onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || event.charCode == 32"
                  required
                />
                <mat-error
                  *ngIf="form.controls['customerName'].hasError('required')"
                  >Customer Name is required.</mat-error
                >
                <mat-error
                  *ngIf="form.controls['customerName'].hasError('pattern')"
                  >Invalid Customer Name</mat-error
                >
              </mat-form-field>
            </mat-grid-list>

            <mat-grid-list cols="3" rowHeight="70px" gutterSize="15px">
              <mat-form-field appearance="outline">
                <mat-label>Mobile Number</mat-label>
                <input
                  type="number"
                  matInput
                  max="10"
                  min="10"
                  (keydown)="maxValue($event)"
                  formControlName="mobileNo"
                  placeholder="Enter Mobile Number"
                  required
                />
                <mat-error
                  *ngIf="form.controls['mobileNo'].hasError('required')"
                  >Mobile Number is required.</mat-error
                >
                <mat-error *ngIf="form.controls['mobileNo'].hasError('pattern')"
                  >Invalid Mobile Number</mat-error
                >
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label> Amount</mat-label>
                <input
                  type="text"
                  matInput
                  formControlName="amount"
                  placeholder="Enter Amount"
                  maxlength="20"
                  required
                />
                <mat-error *ngIf="form.controls['amount'].hasError('required')">
                  Amount is required.</mat-error
                >
                <mat-error *ngIf="form.controls['amount'].hasError('pattern')"
                  >Invalid Amount</mat-error
                >
              </mat-form-field>
            </mat-grid-list>

            <mat-grid-list cols="2" rowHeight="30px" gutterSize="15px">
              <section class="example-section">
                <mat-checkbox
                  id="checkbox"
                  [(ngModel)]="checkboxValue"
                  [ngModelOptions]="{ standalone: true }"
                >
                  I accept below
                  <a href="#" (click)="openTermsAndConditionsPopup($event)"
                    >Terms & Conditions</a
                  >
                </mat-checkbox>
                <mat-error *ngIf="formSubmitted && !checkboxValue"
                  >You must accept the terms and conditions.</mat-error
                >
              </section>
            </mat-grid-list>

            <mat-grid-list cols="2" rowHeight="90px" gutterSize="15px">
              <section class="example-section">
                <!-- <mat-form-field appearance="outline" style="margin-left:0px !important;">
                            <mat-label>INR</mat-label>
                            <input type="text" matInput value="{{this.form.controls.amount.value | number}}" formControlName="inrAmount" [value]="amount" readonly>
                          </mat-form-field>                          -->
                <button
                  mat-raised-button
                  color="primary"
                  type="submit"
                  (click)="submitQrDetails()"
                  class="button-left"
                >
                  PAY NOW
                </button>
              </section>
            </mat-grid-list>
          </form>
        </section>
      </div>

      <div>
        <form
          target="_top"
          #txnForm
          [formGroup]="tranxnForm"
          method="POST"
          action="{{ isgPay_url }}"
        >
          <input
            type="hidden"
            [value]="EncDataField"
            name="EncData"
            formControlName="EncData"
          />
          <input
            type="hidden"
            [value]="MerchantIdField"
            name="MerchantId"
            formControlName="MerchantId"
          />
          <input
            type="hidden"
            [value]="BankIdField"
            name="BankId"
            formControlName="BankId"
          />
          <input
            type="hidden"
            [value]="TerminalIdField"
            name="TerminalId"
            formControlName="TerminalId"
          />
          <input
            type="hidden"
            [value]="VersionField"
            name="Version"
            formControlName="Version"
          />
          <input
            type="hidden"
            [value]="TransactionId"
            name="OrderId"
            formControlName="TransactionId"
          />

          <input
            type="hidden"
            [value]="emailId"
            name="Email"
            formControlName="emailId"
          />

          <input
            type="hidden"
            [value]="mobileNo"
            name="Phone"
            formControlName="mobileNo"
          />

          <input
            type="hidden"
            [value]="firstName"
            name="FirstName"
            formControlName="firstName"
          />

          <input
            type="hidden"
            [value]="lastName"
            name="LastName"
            formControlName="lastName"
          />
        </form>
      </div>
    </div>
  </div>
</div>

<div class="footer" role="banner">
  <mat-grid-list cols="2" rowHeight="50px" gutterSize="15px">
    <section class="example-section">
      <img
        alt="Angular Logo"
        src="assets/images/poweredBy.png"
        class="img-center"
      />
    </section>
  </mat-grid-list>

  <mat-grid-list cols="2" rowHeight="50px" gutterSize="15px">
    <section class="example-section top-space">
      <img alt="Angular Logo" src="assets/images/UPI.svg" class="img-logos" />
      <img alt="Angular Logo" src="assets/images/RuPay.svg" class="img-logos" />
      <img alt="Angular Logo" src="assets/images/VISA.svg" class="img-logos" />
      <img
        alt="Angular Logo"
        src="assets/images/MasterCard.svg"
        class="img-logos"
      />
    </section>
  </mat-grid-list>
</div>

<!-- <router-outlet></router-outlet> -->
<!-- <app-trimble-fee-details></app-trimble-fee-details> -->

<!-- </div>
</div>
</div> -->

<!-- <ng-template #confirmMblBox >
<img src="assets/images/sucess.png" class="md-card-image" alt="image caption" />
<br>
<mat-dialog-content style="text-align: center">
Your complaint has been registered <br>
successfully. <br>
Mention below reference number <br>
for further inquiry.
<br>
<h2 class="mat-h2">Reference number : </h2>
</mat-dialog-content>
<mat-dialog-actions align="end">
<button mat-button  [mat-dialog-close] color="primary"  class=" BTN"  > OK </button>
</mat-dialog-actions>
</ng-template> -->
